export default interface SubmitReportState {
  courses: StudentCourseDailyReportView[];
  satisfied: boolean;
  wakeUpAtHour: number | null;
  wakeUpAtMinute: number | null;
  sleepAtHour: number | null;
  sleepAtMinute: number | null;
  electronicUsageAtHour: number | null;
  electronicUsageAtMinute: number | null;
  showForm: boolean;
  notValidCourses: ReportErrorCourseView[];
  showValidateModal: boolean;
  showConfirmModal: boolean;
}
export interface SubmitReportProps {}

export interface StudentCourseDailyReportView {
  courseID: number;
  courseTitle: string;
  studyTimeHour: number | null;
  studyTimeMinute: number | null;
  testPassedCount: number | null;
  studyTextResult: string;
}

export interface ReportErrorCourseView {
  courseID: number;
  courseTitle: string;
  studyTimeHourError: string;
  studyTimeMinuteError: string;
  testPassedCountError: string;
  studyTextResultError: string;
}

export enum ValueChangerEnum {
  studyTimeHour,
  studyTimeMinute,
  testPassedCount,
  studyTextResult,
}
